module.exports = __webpack_public_path__ + "videos/mts-main-products-boards.1c58085.webm";